import { Image } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Decorative right-hand side of the CTA banner: the curved shape and the overlapping cut-out image.
 *
 * @param {string} [shapeColor] - CSS colour for the curve, or "transparent" to hide it.
 * @param {Object} [personImage] - CMS image for the cut-out.
 * @returns {JSX.Element}
 */
export default function CTAVisual({ shapeColor, personImage }) {
  const showShape = Boolean(shapeColor) && shapeColor !== "transparent";

  return (
    <div className={classes.ctaBanner__visual} aria-hidden="true">
      {showShape && (
        <div className={classes.ctaBanner__shapeClip}>
          <div className={classes.ctaBanner__shape} style={{ color: shapeColor }}>
            <svg viewBox="0 0 422 276" fill="none">
              <path
                d="M477.028 196.784C439.996 212.123 400.306 220.018 360.224 220.018C320.141 220.018 280.451 212.123 243.42 196.784C206.388 181.445 172.741 158.962 144.398 130.62C116.055 102.277 93.5727 68.6295 78.2338 31.598C62.8948 -5.43342 55 -45.1235 55 -85.2061"
                stroke="currentColor"
                strokeWidth="110"
              />
            </svg>
          </div>
        </div>
      )}

      {personImage?.url && (
        <div className={classes.ctaBanner__person} data-sourceflow-prop="personImage">
          <Image img={personImage.url} size="1000x" alt={personImage.alt ?? ""} />
        </div>
      )}
    </div>
  );
}
